'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBeautifulDnd = require('react-beautiful-dnd');

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactTransitionGroup = require('react-transition-group');

var _uniqueId = require('../../../utils/unique-id');

var _uniqueId2 = _interopRequireDefault(_uniqueId);

var _tableCell = require('../table-cell/table-cell');

var _tableCell2 = _interopRequireDefault(_tableCell);

var _tableRow = require('../table-row/table-row');

var _tableRow2 = _interopRequireDefault(_tableRow);

require('./table-body.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TableBody = function (_React$Component) {
  _inherits(TableBody, _React$Component);

  function TableBody(props) {
    _classCallCheck(this, TableBody);

    var _this = _possibleConstructorReturn(this, (TableBody.__proto__ || Object.getPrototypeOf(TableBody)).call(this, props));

    _this.id = (0, _uniqueId2.default)();
    _this.onDragEnd = _this.onDragEnd.bind(_this);
    return _this;
  }

  _createClass(TableBody, [{
    key: 'onDragEnd',
    value: function onDragEnd(result) {
      // dropped outside the list
      if (!result.destination) {
        return;
      }

      var _props = this.props,
          data = _props.data,
          onReorder = _props.onReorder;

      var startIndex = result.source.index;
      var endIndex = result.destination.index;

      var reorderedData = Array.from(data);

      var _reorderedData$splice = reorderedData.splice(startIndex, 1),
          _reorderedData$splice2 = _slicedToArray(_reorderedData$splice, 1),
          removed = _reorderedData$splice2[0];

      reorderedData.splice(endIndex, 0, removed);

      onReorder(reorderedData);
    }
  }, {
    key: 'getRowKey',
    value: function getRowKey(row) {
      var rowKey = this.props.rowKey;


      return row[rowKey] || JSON.stringify(row);
    }
  }, {
    key: 'getTransitionGroupProps',
    value: function getTransitionGroupProps(provided, snapshot) {
      var defaultProps = {
        className: 'table__body',
        component: 'tbody'
      };

      if (this.props.reordable && provided && snapshot) {
        return _extends({}, defaultProps, {
          id: this.id,
          ref: function ref(_ref) {
            return _ref && provided.innerRef(document.querySelector('#' + _ref.props.id));
          },
          style: {
            background: '#25b8d2',
            width: '100%'
          }
        });
      }

      return defaultProps;
    }
  }, {
    key: 'getCSSTransitionProps',
    value: function getCSSTransitionProps(row) {
      return {
        key: this.getRowKey(row),
        classNames: 'table__row--animation',
        timeout: 500
      };
    }
  }, {
    key: 'getTableRowProps',
    value: function getTableRowProps(row, provided, snapshot) {
      var _props2 = this.props,
          onContextMenuHandler = _props2.onContextMenuHandler,
          _onRowPress = _props2.onRowPress,
          _onRowTap = _props2.onRowTap,
          reordable = _props2.reordable,
          rowSelectionHandler = _props2.rowSelectionHandler,
          shouldRowLoading = _props2.shouldRowLoading;


      var defaultProps = {
        onContextMenu: function onContextMenu() {
          return onContextMenuHandler(row);
        },
        onRowTap: function onRowTap(event) {
          rowSelectionHandler(row, event);
          _onRowTap(row, event);
        },
        onRowPress: function onRowPress(event) {
          return _onRowPress(row, event);
        },
        loading: shouldRowLoading(row)
      };

      if (reordable && provided && snapshot) {
        return _extends({}, defaultProps, {
          dragAndDrop: _extends({}, provided.draggableProps, provided.dragHandleProps),
          onRefsReady: provided.innerRef,
          style: _extends({
            // some basic styles to make the items look a bit nicer
            userSelect: 'none'

          }, provided.draggableProps.style)
        });
      }

      return defaultProps;
    }
  }, {
    key: 'isRowExpanded',
    value: function isRowExpanded(row) {
      var _props3 = this.props,
          isExpandedRowInComponentProps = _props3.isExpandedRowInComponentProps,
          expandableTemplate = _props3.expandableTemplate;


      var expandable = Boolean(expandableTemplate);
      return isExpandedRowInComponentProps(row) && expandable;
    }
  }, {
    key: 'renderTableCell',
    value: function renderTableCell(_ref2) {
      var column = _ref2.column,
          index = _ref2.index,
          rowIndex = _ref2.rowIndex;
      var _props4 = this.props,
          data = _props4.data,
          isSelectedRowInComponentState = _props4.isSelectedRowInComponentState,
          selectedColumns = _props4.selectedColumns;

      var currentRow = data[rowIndex];
      var cellContent = currentRow[column.accessor];
      var cellChild = column.render ? column.render(cellContent, currentRow) : cellContent;
      var isInColumnSelection = selectedColumns.includes(index);
      var isRowSelected = isSelectedRowInComponentState(currentRow);

      return _react2.default.createElement(
        _tableCell2.default,
        {
          key: rowIndex + '-' + index,
          dataAttributes: {
            'data-label': typeof column.header === 'string' ? column.header : null,
            'data-cell-index': index,
            'data-row-index': rowIndex
          },
          isInColumnSelection: isInColumnSelection,
          isInRowSelection: isRowSelected,
          isText: typeof cellChild === 'string',
          style: column.style
        },
        cellChild
      );
    }
  }, {
    key: 'renderTableRow',
    value: function renderTableRow(_ref3) {
      var _this2 = this;

      var row = _ref3.row,
          rowIndex = _ref3.rowIndex,
          draggableProvided = _ref3.draggableProvided,
          draggableSnapshot = _ref3.draggableSnapshot;
      var columns = this.props.columns;


      return _react2.default.createElement(
        _tableRow2.default,
        this.getTableRowProps(row, draggableProvided, draggableSnapshot),
        columns.map(function (column, index) {
          return _this2.renderTableCell({ column: column, index: index, rowIndex: rowIndex });
        })
      );
    }
  }, {
    key: 'renderTableBody',
    value: function renderTableBody() {
      var _this3 = this;

      var _props5 = this.props,
          columns = _props5.columns,
          data = _props5.data,
          expandableTemplate = _props5.expandableTemplate;


      return _react2.default.createElement(
        _reactTransitionGroup.TransitionGroup,
        this.getTransitionGroupProps(),
        data.map(function (row, rowIndex) {
          return _react2.default.createElement(
            _reactTransitionGroup.CSSTransition,
            _this3.getCSSTransitionProps(row),
            _react2.default.createElement(
              _react2.default.Fragment,
              null,
              _react2.default.createElement(
                _tableRow2.default,
                _extends({}, _this3.getTableRowProps(row), {
                  className: _this3.isRowExpanded(row) ? 'table__row-expanded' : null
                }),
                columns.map(function (column, index) {
                  return _this3.renderTableCell({ column: column, index: index, rowIndex: rowIndex });
                })
              ),
              _this3.isRowExpanded(row) && _react2.default.createElement(
                _tableRow2.default,
                null,
                _react2.default.createElement(
                  _tableCell2.default,
                  {
                    className: 'table__cell-expandable-wrapper',
                    dataAttributes: { colSpan: columns.length },
                    style: { padding: 0 }
                  },
                  expandableTemplate(row, rowIndex)
                )
              )
            )
          );
        })
      );
    }
  }, {
    key: 'renderTableReorderableBody',
    value: function renderTableReorderableBody() {
      var _this4 = this;

      var data = this.props.data;


      return _react2.default.createElement(
        _reactBeautifulDnd.DragDropContext,
        { onDragEnd: this.onDragEnd },
        _react2.default.createElement(
          _reactBeautifulDnd.Droppable,
          { droppableId: 'droppable' },
          function (provided, snapshot) {
            return _react2.default.createElement(
              _reactTransitionGroup.TransitionGroup,
              _this4.getTransitionGroupProps(provided, snapshot),
              data.map(function (row, rowIndex) {
                return _react2.default.createElement(
                  _reactTransitionGroup.CSSTransition,
                  _this4.getCSSTransitionProps(row, provided, snapshot),
                  _react2.default.createElement(
                    _reactBeautifulDnd.Draggable,
                    { key: _this4.getRowKey(row), draggableId: _this4.getRowKey(row), index: rowIndex },
                    function (draggableProvided, draggableSnapshot) {
                      // Due to Section will-change, we need to use React Portal
                      if (draggableSnapshot.isDragging) {
                        return _reactDom2.default.createPortal(_react2.default.createElement(
                          'table',
                          { className: 'table-dnd-placeholder' },
                          _react2.default.createElement(
                            'tbody',
                            null,
                            _this4.renderTableRow({ row: row, rowIndex: rowIndex, draggableProvided: draggableProvided, draggableSnapshot: draggableSnapshot })
                          )
                        ), document.body);
                      }

                      return _this4.renderTableRow({ row: row, rowIndex: rowIndex, draggableProvided: draggableProvided, draggableSnapshot: draggableSnapshot });
                    }
                  )
                );
              }),
              provided.placeholder
            );
          }
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.reordable ? this.renderTableReorderableBody() : this.renderTableBody();
    }
  }]);

  return TableBody;
}(_react2.default.Component);

TableBody.propTypes = {
  columns: _propTypes2.default.array,
  data: _propTypes2.default.array,
  expandableTemplate: _propTypes2.default.node,
  isExpandedRowInComponentProps: _propTypes2.default.func,
  isSelectedRowInComponentState: _propTypes2.default.func,
  onContextMenuHandler: _propTypes2.default.func,
  onReorder: _propTypes2.default.func,
  onRowPress: _propTypes2.default.func,
  onRowTap: _propTypes2.default.func,
  reordable: _propTypes2.default.bool,
  rowKey: _propTypes2.default.string,
  rowSelectionHandler: _propTypes2.default.func,
  selectedColumns: _propTypes2.default.array,
  shouldRowLoading: _propTypes2.default.func
};

_tableRow2.default.defaultProps = {};

exports.default = TableBody;